export function IsInRole(userObject,role){

    //console.log(userObject);
    

        for(let i=0;i<userObject.Roles.length;i++){
            if(userObject.Roles[i].trim()==role.trim()){
                return true;
            }
        }
    
    return false;
}
export function twoDigit(n) {
    return ("0" + n).slice(-2);
}
export function numberWithCommas(value, fix) {
    value = Number(value).toFixed(fix);
    //return value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}


export function stringToDateWithTime(stringDate){
    let dateObject = stringToDayObject_local(stringDate) ;
    //console.log(dateObject);
    //alert("debug");


    let resText = dateObject.date + "/" + dateObject.month2digit + "/" + dateObject.year +" "+dateObject.hours2digit+":"+dateObject.minutes2digit;

    return resText;
}

function stringToDayObject_local(stringDate) {

    let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    let months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"
    ];



    let d = new Date(stringDate);
    let dayName = days[d.getDay()];
    let shortDayName = dayName.substr(0, 3);
    let month2digit = ("0" + (d.getMonth() + 1)).slice(-2);
    let monthName = months[d.getMonth()];
    let shortMonthName = monthName.substr(0, 3);
    let shortYear = d.getFullYear().toString().substr(-2);

    let result = {};
    result.dayName = dayName;
    result.shortDayName = shortDayName;
    result.monthName = monthName;
    result.shortMonthName = shortMonthName;
    result.month2digit =  month2digit;
    result.hours = d.getHours();
    result.hours2digit = ("0" + result.hours).slice(-2);
    result.minutes = d.getMinutes();
    result.minutes2digit = ("0" + result.minutes).slice(-2);
    result.date = d.getDate();
    result.year = d.getFullYear();



    result.shortYear = shortYear;

    return result;
}




